export default __webpack_public_path__ + "static/media/pokoj-prizemi.469fd208.jpeg";